import { createElement, styled, compose, position, space, layout, flexbox, color, typography, border, opacity, float, boxShadow, pointerEvents, boxSizing, visibility, transition, textOverflow, textDecoration, textTransform, outline, cursor, whiteSpace, wordWrap } from '@vebox/etui-system';

const InputElement = createElement('input');
const Input = styled(InputElement)(compose(position, space, layout, flexbox, color, typography, border, opacity, float, boxShadow, pointerEvents, boxSizing, visibility, transition, textOverflow, textDecoration, textTransform, outline, cursor, whiteSpace, wordWrap));
Input.displayName = 'Input';

export { Input };
